var map = {
	"./en/auth.json": 1272,
	"./en/customize.json": 1669,
	"./en/dashboard.json": 3638,
	"./en/eggfreeze.json": 2284,
	"./en/embryo.json": 2352,
	"./en/general.json": 7886,
	"./en/manage.json": 9797,
	"./en/oocyte.json": 1859,
	"./en/settings.json": 8871,
	"./en/sperm.json": 8577,
	"./he/auth.json": 9648,
	"./he/customize.json": 797,
	"./he/dashboard.json": 1726,
	"./he/eggfreeze.json": 1316,
	"./he/embryo.json": 6152,
	"./he/general.json": 5366,
	"./he/manage.json": 4125,
	"./he/oocyte.json": 5787,
	"./he/settings.json": 5647,
	"./ko/auth.json": 4307,
	"./ko/customize.json": 8900,
	"./ko/dashboard.json": 3623,
	"./ko/eggfreeze.json": 2178,
	"./ko/embryo.json": 2915,
	"./ko/general.json": 5735,
	"./ko/manage.json": 8942,
	"./ko/oocyte.json": 2916,
	"./ko/settings.json": 2276,
	"./ms/auth.json": 9549,
	"./ms/customize.json": 1034,
	"./ms/dashboard.json": 5165,
	"./ms/eggfreeze.json": 4759,
	"./ms/embryo.json": 5265,
	"./ms/general.json": 7889,
	"./ms/manage.json": 2960,
	"./ms/oocyte.json": 754,
	"./ms/settings.json": 2734,
	"./my/auth.json": 9923,
	"./my/customize.json": 932,
	"./my/dashboard.json": 2487,
	"./my/eggfreeze.json": 6789,
	"./my/embryo.json": 51,
	"./my/general.json": 1639,
	"./my/manage.json": 4142,
	"./my/oocyte.json": 7268,
	"./my/settings.json": 9172,
	"./th/auth.json": 8009,
	"./th/customize.json": 2550,
	"./th/dashboard.json": 761,
	"./th/eggfreeze.json": 4819,
	"./th/embryo.json": 6069,
	"./th/general.json": 45,
	"./th/manage.json": 8156,
	"./th/oocyte.json": 222,
	"./th/settings.json": 2306,
	"./vi/auth.json": 4474,
	"./vi/customize.json": 6067,
	"./vi/dashboard.json": 2764,
	"./vi/eggfreeze.json": 4126,
	"./vi/embryo.json": 7294,
	"./vi/general.json": 632,
	"./vi/manage.json": 5743,
	"./vi/oocyte.json": 6289,
	"./vi/settings.json": 4705,
	"./zh-CN/auth.json": 2833,
	"./zh-CN/customize.json": 190,
	"./zh-CN/dashboard.json": 7777,
	"./zh-CN/eggfreeze.json": 8267,
	"./zh-CN/embryo.json": 2426,
	"./zh-CN/general.json": 2453,
	"./zh-CN/manage.json": 6276,
	"./zh-CN/oocyte.json": 2166,
	"./zh-CN/settings.json": 9498,
	"./zh-TW/auth.json": 5477,
	"./zh-TW/customize.json": 7794,
	"./zh-TW/dashboard.json": 9429,
	"./zh-TW/eggfreeze.json": 1199,
	"./zh-TW/embryo.json": 1913,
	"./zh-TW/general.json": 905,
	"./zh-TW/manage.json": 6712,
	"./zh-TW/oocyte.json": 1674,
	"./zh-TW/settings.json": 4310
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1852;